import React, { useState } from 'react';
import { Form, InputGroup, Input, Button, InputGroupAddon } from 'reactstrap';
import { CommonHeadFooter, NewsLetterBoxPadding, NewsletterHead, NewsLetterP, NewsLetterText, Rectangle } from '../../../../StyledComponents'
import { Col, Row } from 'reactstrap'
import abc from '../../../../assets/images/icons/Rectangle.svg'



const NewsLetter = () => {

  const [email, setEmail] = useState('');


  const emailInpStyle = {
    fontFamily: "Inter",
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "29.05px",
    textAlign: "left",
  }



  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here (e.g., send email to backend)
    console.log("Submitted email:", email);
  };


  return (
    <div style={{backgroundColor:"#FBBD34", color:'white', display:'flex', justifyContent:'center',flexDirection:'column', alignItems:'center', paddingBottom:'30px'}}>
        <div style={{paddingTop:'35px'}}>
          <NewsletterHead>Newsletter of Maelano</NewsletterHead>
        </div>
        <div style={{backgroundColor:'orange', width:'87%'}}>
          <NewsLetterBoxPadding>
            <NewsLetterText>Mark up the points of interests to receive the newsletter from Maelano</NewsLetterText>
            <NewsLetterP >
              <Row>
                <Col className='d-flex align-items-center' lg='6' style={{marginBottom:'19px'}}> <Rectangle src={abc} /> <div>Get the latest updates and offers</div> </Col>
                <Col className='d-flex align-items-center' lg='6' style={{marginBottom:'19px'}}> <Rectangle src={abc} /> <div>Top brands and newly arrived products</div> </Col>
                <Col className='d-flex align-items-center' lg='6'> <Rectangle src={abc} /> <div>Benefit from exclusive discounts</div> </Col>
                <Col className='d-flex align-items-center' lg='6'> <Rectangle src={abc} /> <div>Never miss special promotions</div> </Col>
                
              </Row>
            </NewsLetterP>
          </NewsLetterBoxPadding>
        </div>
            <div style={{width:'87%', marginTop:'33px', marginBottom:'33px'}}>
              <div style={{display:'flex', flexDirection:'row', flexWrap:'nowrap', marginBottom:'18px'}}>
                    <Rectangle src={abc} />
                    <CommonHeadFooter>Yes, i would like to receive the news letter selected above by email and therefore consent to the collection and processing of the mandatory data in accordance with the <u>Standard Newsletter chapter of the data protection principles</u>. I can revoke my consent at any time. Until revoked, dat a processing based on this consent is lawful.</CommonHeadFooter>
              </div>
              <div style={{display:'flex', flexDirection:'row', flexWrap:'nowrap'}}>
                    <Rectangle src={abc} />
                    <CommonHeadFooter>
                      Yes, in addition to ordering the newsletter, i also consent to the newsletter being linked to my Maelano customer account in accordance with the chapter <u>Consent to the personalization of the newsletter</u>. This means that the content of the newsletter is adopted to my interests according to transaction (e.g. purchase history) and if, I consent to to cookies, to my clicking and surfing behavior on the Maelano websites amd the app to my reading behavior in the newsletter.
                    </CommonHeadFooter>
              </div>
            </div>
            <div style={{ width: '87%', display: 'flex', justifyContent: 'flex-end' }}>
              <Form onSubmit={handleSubmit} >
                <InputGroup>
                <Input
                style={emailInpStyle}
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {/* <InputGroupAddon addonType="append"> */}
                  <div >
                    <Button type="submit" color='Warning' style={{ ...emailInpStyle, backgroundColor: '#EC7426', color: 'white' }}>
                      Submit
                    </Button>
                  </div>
                  {/* </InputGroupAddon> */}
                </InputGroup>
              </Form>
            </div>
    </div>
  )
}

export default NewsLetter